import { ApolloProvider } from '@apollo/client';
import { ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import { COGNITO_ENV_ADMIN } from '@uptime/shared/constants/cognito';
import { CognitoProvider } from '@uptime/shared/providers/CognitoProvider';
import UIProvider from '@uptime/shared/providers/UIProvider';
import muiTheme from '@uptime/shared/theme/muiTheme';
import ThemedSnackbar from '@uptime/shared/theme/ThemedSnackbar';

import App from './App';
import { client } from './graphql/apolloClient';
import PermissionsProvider from './providers/PermissionsProvider';
import { persistor, store } from './store';

import './index.css';

// @ts-expect-error attach store to window for testing purposes
window.store = store;

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <CognitoProvider cognitoEnv={COGNITO_ENV_ADMIN}>
          <ApolloProvider client={client}>
            <SnackbarProvider
              maxSnack={3}
              autoHideDuration={8000}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              Components={{
                success: ThemedSnackbar,
                error: ThemedSnackbar,
                warning: ThemedSnackbar,
                info: ThemedSnackbar,
              }}
            >
              <ThemeProvider theme={muiTheme}>
                <PermissionsProvider>
                  <UIProvider>
                    <App />
                  </UIProvider>
                </PermissionsProvider>
              </ThemeProvider>
            </SnackbarProvider>
          </ApolloProvider>
        </CognitoProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);
